import { render, staticRenderFns } from "./GeorepreportForm.vue?vue&type=template&id=89362688"
import script from "./GeorepreportForm.vue?vue&type=script&lang=js"
export * from "./GeorepreportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports